export default function fullAddress({
  city,
  address,
  zipCode,
}: {
  city?: string | null;
  address?: string | null;
  zipCode?: string | null;
}): string | undefined {
  if (address && zipCode && city) {
    return `${address}, ${zipCode} ${city}`;
  }

  if (address && zipCode) {
    return `${address}, ${zipCode}`;
  }

  if (address && city) {
    return `${address}, ${city}`;
  }

  if (address) {
    return address;
  }
}
